import type { DesktopTextDocument } from "@rakazo/contracts";

/**
 * Documents the desktop has handed over, held against the draft they were opened as.
 *
 * Every editor window is mounted at once, so a shared queue let whichever window happened to run
 * first take a document meant for another. Keying by draft sends each document to exactly one
 * window: the one opened to show it.
 */
const pending = new Map<string, DesktopTextDocument>();

export function holdEditorDocument(draft: string, document: DesktopTextDocument) {
  pending.set(draft, document);
}

export function takeEditorDocument(draft: string): DesktopTextDocument | null {
  const document = pending.get(draft) ?? null;
  if (document) pending.delete(draft);
  return document;
}

export function hasEditorDocument(draft: string) {
  return pending.has(draft);
}
